import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function ForgotPasswordDialogFooter({ result, submit, close, isLoading }) {
  if (!result) {
    return (
      <div className="els-btn-group-right forgot-password-dialog__footer">
        <ButtonWithIcon
          type="primary"
          sprite="ChevronRight"
          iconRight
          className="e2e-forgot-password-continue"
          disabled={isLoading}
          onClick={submit}>
          Send me a recovery email
        </ButtonWithIcon>
      </div>
    );
  }
  return (
    <div className="els-btn-group-right forgot-password-dialog__footer">
      <ButtonWithIcon type="primary" sprite="ChevronRight" iconRight className="e2e-forgot-password-close" onClick={close}>
        OK, got it
      </ButtonWithIcon>
    </div>
  );
}

ForgotPasswordDialogFooter.propTypes = {
  result: PropTypes.string,
  submit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default ForgotPasswordDialogFooter;
